module.exports = __webpack_public_path__ + "static/trees-3.1-14159d8f6a7b4d0c79d208d6289e2d86.png";